export default __webpack_public_path__ + "../staticImages/voucher_modal.jpg";